import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Preselect } from './preselect';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PreselectType } from '../types';
import { ProductOptType } from '../types';

const _schema = {
    "name": "PRESELECTOPT",
    "fields": [
        { name: "status", type: "string" },
        { name: "preselect", type: "objid", alias: "select" },
        { name: "prodopt", type: "objid", alias: "option" },
    ],
    relate: [
        { direction: ">", target: "PRESELECT", by: "select", name: "select", reason: "select", child: false, class: PreselectType },
        { direction: ">", target: "PRODUCTOPT", by: "option", name: "option", reason: "option", child: false, class: ProductOptType }
    ]
} as const;

const _PreselectOptClass = CreateObject(_schema);
if (!_PreselectOptClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class PreselectOpt extends _PreselectOptClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): PreselectOpt {
        return this._Copy(store) as PreselectOpt;
    }

    /**
     * A PRESELECTOPT row arriving through `_CHANGESLOG` does not carry the parent PRESELECT children list
     * (`options` only travels on full load). Register in the parent when the `select` link is set
     * (idempotent). Only rows already in the database register here: drafts join their shortcut
     * explicitly (`PreselectView.AddOption`) and copies build their lists in `_Copy`.
     */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited || relation !== 'select' || !(related instanceof Preselect)){
            return;
        }

        if (related === this.select){
            related.AddOption(this);
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.select){
            if ((this.status == 'DE') && !this.Commited){
                this.select.DelOption(this);
            }
            else {
                this.select.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CATALOG CONSIDERATIONS   */
    /****************************/

    override get IsCatalog(): boolean {
        return super.IsCatalog;
    }

    override set IsCatalog(value: boolean){
        if (value == this.IsCatalog){
            return;
        }

        super.IsCatalog = value;
        if (value == false){
            if (this.status == 'CT'){
                this.status = 'AC';
            }

            for (const _child of this.Children){
                _child.IsCatalog = value;
            }
        }
    }
        
    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }    
}

